import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=0e45ec21"
import script from "./Languages.vue?vue&type=script&setup=true&lang=js"
export * from "./Languages.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports